import { useEffect, useState } from 'react'

/**
 * Enrutador mínimo sin dependencias.
 *
 * El sitio tiene un puñado de tipos de página (inicio, detalle de producto,
 * perfil, admin, las dos legales y la wiki de educación con sus lecciones),
 * pero todas resuelven con el mismo patrón simple (comparar `pathname` o
 * matchear una regex), así que no se justifica una librería de routing:
 * History API + un evento propio bastan. `firebase.json` ya reescribe
 * cualquier ruta a index.html, así que una carga directa de /producto/algo
 * funciona igual que recargar en caliente.
 */
const EVENTO_NAVEGACION = 'spa:navegacion'

function leerRuta() {
  return window.location.pathname
}

/** Para usar fuera de un componente (p. ej. dentro de otro hook). */
export function navegar(destino) {
  window.history.pushState(null, '', destino)
  window.dispatchEvent(new Event(EVENTO_NAVEGACION))
}

export function useRuta() {
  const [ruta, setRuta] = useState(leerRuta)

  useEffect(() => {
    const actualizar = () => setRuta(leerRuta())
    window.addEventListener('popstate', actualizar)
    window.addEventListener(EVENTO_NAVEGACION, actualizar)
    return () => {
      window.removeEventListener('popstate', actualizar)
      window.removeEventListener(EVENTO_NAVEGACION, actualizar)
    }
  }, [])

  return ruta
}
